import { render, staticRenderFns } from "./MigrateData.vue?vue&type=template&id=f1753794&scoped=true&"
import script from "./MigrateData.vue?vue&type=script&lang=js&"
export * from "./MigrateData.vue?vue&type=script&lang=js&"
import style0 from "./MigrateData.vue?vue&type=style&index=0&id=f1753794&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1753794",
  null
  
)

export default component.exports